<div class="dialog-container">
  <div
    *ngFor="let title of data.titles; let last = last"
    class="dialog-title"
    (click)="action(title)"
  >
    {{ title }}
  </div>
</div>
